// account
export const REGISTER = '/account/register/';
export const BROKERREGISTER = '/broker/register/';
export const BROKEREDIT = '/broker/edit/';
export const BROKERVERIFY = '/broker/verify/';
export const NOTIFY = '/account/save-email/';
export const LOGININTERNAL = '/account/login-internal/';
export const LOGINCUSTOMER = '/account/login-customer/';
export const BROKERLOGINCUSTOMER = '/broker/logincustomer/';
export const FORGOT = '/account/forgot-password/';
export const FORGOTCHANGEPASSWORD = '/account/change-password/';
export const CHANGE = '/account/change-customer-password/';
export const MYSITEVISITS = '/account/site-visit-details/';
export const NEARBY = '/project/nearby/';
export const MYPROFILE = '/account/customer-settings/';
export const GETBROKERFAVOURITES = '/account/get-broker-user-favourites/';
export const BROKERACCOUNT = '/account/broker-user/';
export const MYPROJECTS = '/account/get-user-projects/';
export const REFERRAL = '/account/add-referral/';
export const CONTACTUS = '/account/contact-us/';
export const ADDNOTE = '/account/add-note/';
export const LOGOUT = '/account/logout/';
export const SENDOTP = '/account/send-otp/';
export const VERIFYOTP = '/account/verify-otp/';
export const ADDPHONE = '/account/add-phone/';
export const VERIFYEMAIL = '/account/verify-email/';
export const ABORTBOOKING = '/auction/booking-aborted/';
export const RESENDEMAIL = '/account/resend-email/';
export const GETUSERINFO = '/account/getuserinfo/';
export const WITHDRAWBID = '/auction/bid/bid-id/withdraw/';
export const SURVEY = '/account/survey/';

// project
export const HOME = '/project/v1/home/';
export const PROJECTMASTER = '/project/v1/internal-master/';
export const STATISTICS = '/project/statistics/';
export const SITEVISIT = '/project/sitevisit/';
export const PROJECTDETAILS = '/project/v1/project-details/';
export const UNITDETAILS = '/project/v1/project-details/id/units/';
export const BUILDERDETAILS = '/project/builder-details/';
export const PROJECTFAVOURITE = '/project/my-favourites/';
export const COMPARE = '/project/compare/';
export const GETBUILDERS = '/project/get-all-builders/';
export const ADDINVENTORY = '/project/inventory/';
export const FOOTERPROJECTS = '/project/get-locality-data/';
export const GETLOCALITIES = '/project/get-new-project-locality-data/';
export const GETTAGS = '/project/get-tag-data/';
export const GETEXCLUSIVEPROJECTS = '/project/exclusive-projects/';
export const GETUNITCOST = '/project/get-unit-additional-cost/';
export const GETDEVLIST = '/project/get-developers-list/';
export const GETCOMPAREPROJECT = '/project/compare-projects/';
export const GETPROJECTLIST = '/project/project-list/';

// search
export const SEARCH = '/project/search/';
export const SEARCHDETAILS = '/project/search/details/';

// Internal
export const MYACTIVITY = '/internal/my-activity/';
export const USERS = '/internal/users/';
export const OTHERUSEERS = '/internal/get-non-internal-users/';
export const BROKERAPPROVALS = '/broker/approvals/';
export const BROKERREMARK = '/broker/remark/';
export const BROKERSITEVISIT = '/broker/sitevisit/';
export const GETUNITDETAILS = '/project/get-unit-details/';
export const DELETEUNIT = '/project/unit/';
export const GETINVENTORYPROJECTDETAILS = '/project/get-project-details-for-inventory/';
export const INTERNALNOTIFICATIONS = '/account/internal-notification-settings/';
export const PROJECTRMDETAILS = '/internal/rm-details-for-project/';
export const UPDATERMSTATUS = '/internal/update-rm-active-status/';
export const CUSTOMERSANDBROKERSLIST = '/account/getcustomers/';
export const AGENTCUSTOMERS = '/internal/customer-details-for-agent/';
export const AGENTRMS = '/internal/rm-details-of-project-for-agent/';
export const GETDRMLIST = '/internal/get-drm-list/';
export const GETFORMULAE = '/project/get-all-formula-fields/';

// Relationship Manager (RM)
export const RMASSIGN = '/rm/assign/';
export const RMCUSTOMERS = '/rm/customer-list/';
export const RMBROKERS = '/rm/broker-list/';
export const PASTAUCTIONS = '/rm/past-auctions/';
export const BIDDETAILS = '/rm/bid-details/';
export const RMLIVE = '/rm/live/';
export const RMPROJECTS = '/rm/projects/';
export const RMADDNOTE = '/rm/add-note/';
export const GETRM = '/internal/rms/';
export const CUSTOMERCHEQUE = '/project/cheque-image-upload/';
export const INCREASETIME = '/auction/extend-time-for-payment-for-customer/';

// BD
export const VERIFYPROJECT = '/project/verify/';
export const EDITANDVERIFY = '/project/inventory-edit-and-verify/';

// Sales Head (SH)
export const SHCUSTOMERS = '/sales-head/get-customer-broker-list/';
export const SHBROKERS = 'sales-head/broker-list/';
export const SHPROJECTS = '/sales-head/projects/';
export const BROKERLISTWITHDRM = '/broker/all/';
export const EDITDRM = '/sales-head/edit-drm/';

// Auctioneer
export const CLOSEAUCTION = '/auction/close-auction/';
export const DROPPRICE = '/auction/drop-price/';
export const GETAUCTION = '/auction/edit-auction-popup/';
export const GETVALUELISTING = '/auction/value-listing-popup/';
export const EDITAUCTION = '/auction/schedule-auction/';
export const AUCTIONEERLIVE = '/auction/auctioneer-live/';
export const VALUELISTING = '/auction/value-listing/';

// Broker
export const BROKERPROJECTS = '/broker/projects/';
export const LIVEPROJECTS = '/project/live-project-list/';
export const BROKERFAVOURITES = '/broker/favourite/';
export const BROKERCUSTOMERS = '/broker/customers/';
export const BROKERADDCUSTOMERS = '/broker/addcustomer/';
export const BROKERCUSTOMERUPLOAD = '/broker/customerupload/';
export const BROKERADDEDCUSTOMERS = '/broker/myaddedcustomers/';
export const BROKEREDITCUSTOMERS = '/broker/editcustomer/';
export const BROKERCUSTOMERBID = 'broker/assigncustomer/';

// DRM
export const DRMBROKERS = '/internal/drm-broker-list/';

// Auction
export const BID = '/auction/bid/';
export const AUCTIONVALUELISTING = '/auction/value-listing/';
export const BOOK = '/auction/book/';
export const BULKINVENTORY = '/project/bulk-inventory/';
export const PROJECTIMAGE = '/project/project-image/';
export const RELEASEUNIT = '/rm/release-unit/';
export const RESERVEUNIT = '/rm/reserve-unit/';
export const DELETERESERVEUNIT = '/rm/delete-reserve-unit-image/';
export const CHANGERESERVEUNITSTATUS = '/auction/change-reserve-unit-status/';
export const SENDPAYMENTLINK = '/payment/send-payment-link/';
export const PAUSEAUCTION = '/auction/pause-auction/';
export const UNPAUSEAUCTION = 'auction/unpause-auction/';
export const SETPAYMENTTIME = '/auction/change-time-for-payment/';

// Notification
export const GETNOTIFICATIONS = '/notification/get/';
export const EDITNOTIFICATIONS = '/notification/update/';

// Payment
export const PAYMENTDETAILS = '/payment/get-details/';
export const PAYMENTCHECKOUT = '/payment/checkout/';
export const MYPAYMENTS = '/payment/soa/';
export const CANCELBOOKING = '/payment/cancel-booking/';
export const INVOICE = 'payment/invoice/';
export const GETBIDSTRENGTH = '/auction/get-bid-strength/';

// Calling
export const CALL = '/calling/call/';

// Career
export const CAREER = '/account/career/';

// API without loader
export const loaderLessAPIs = [
  PROJECTFAVOURITE,
  GETBROKERFAVOURITES,
];

// APIs that can be called by a guest. Accessable to ALL types of users.
export const guestMapping = [
  PROJECTDETAILS,
  FORGOT,
  FORGOTCHANGEPASSWORD,
  NEARBY,
  REFERRAL,
  CONTACTUS,
  HOME,
  CAREER,
  STATISTICS,
  COMPARE,
  FOOTERPROJECTS,
  SEARCH,
  SEARCHDETAILS,
  GETBIDSTRENGTH,
  GETLOCALITIES,
  GETUNITCOST,
  GETPROJECTLIST,
  GETCOMPAREPROJECT,
  UNITDETAILS,
];

export default {
  REGISTER,
  BROKERREGISTER,
  BROKEREDIT,
  BROKERVERIFY,
  NOTIFY,
  LOGINCUSTOMER,
  LOGININTERNAL,
  FORGOT,
  CHANGE,
  HOME,
  CAREER,
  PROJECTMASTER,
  STATISTICS,
  SITEVISIT,
  MYSITEVISITS,
  SEARCH,
  SEARCHDETAILS,
  NEARBY,
  PROJECTDETAILS,
  BUILDERDETAILS,
  MYPROFILE,
  PROJECTFAVOURITE,
  RMASSIGN,
  COMPARE,
  BROKERPROJECTS,
  LIVEPROJECTS,
  GETBROKERFAVOURITES,
  BROKERFAVOURITES,
  BROKERACCOUNT,
  BROKERCUSTOMERS,
  BROKERADDCUSTOMERS,
  BROKERADDEDCUSTOMERS,
  BROKERCUSTOMERBID,
  USERS,
  RMCUSTOMERS,
  RMBROKERS,
  BID,
  PASTAUCTIONS,
  RMLIVE,
  AUCTIONEERLIVE,
  EDITAUCTION,
  CLOSEAUCTION,
  DROPPRICE,
  CALL,
  REFERRAL,
  GETFORMULAE,
  GETUNITCOST,
  guestMapping,
  loaderLessAPIs,
  RESENDEMAIL,
  GETCOMPAREPROJECT,
  UNITDETAILS,
  WITHDRAWBID,
};



// WEBPACK FOOTER //
// ./src/utils/endpoint.js